define([
    "dojo/_base/declare",
    "csi/table/New",
    "csi/service/sessionService"
], function(declare, New, { initializeRoles }) {

	return declare(New,{
		postProcessSuccess: function() {
			initializeRoles();
			return this.inherited(arguments);
		}
	});
});